import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Ticket } from '@app/modules/model/ticket';
import { Discount } from '@app/modules/model/discount';

import { GenericUtils } from '@app/app.commonutils';
import { languageSupport, languageService } from '@app/modules/common/language'
import { dataService } from '@app/modules/data';
import { viewService } from '@app/modules/view';


@Component({
    selector: 'ui-discount-thumbnail',
    templateUrl:'./ui-thumb.html',
    styleUrls: [ 
        './ui-thumb.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiDiscountThumbnail extends languageSupport implements OnInit, OnDestroy {
    @Input('ticket') _ticket: Ticket = null;
    @Input('discount') _discount: Discount = null;

    private _subscriptions = [];

    normalize(str){
        return GenericUtils.Normalize(str);
    }

    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    private _ticket_subscription = null;

    constructor(private lang: languageService, private change: ChangeDetectorRef, private data: dataService, public view: viewService) {
        super(lang, change);
    }

    private _RefreshTicket(){
        this._discountprice = null;
        this.change.markForCheck();
    }

    ngOnInit(){
        if (this._discount){
            // refresh on offer changes
            this._subscriptions.push(
                this._discount.OnRefresh.subscribe(
                data => {
                    this.change.markForCheck();
                })
            );    

            // refresh on theme changed
            this._subscriptions.push(
                this.view.OnTheme.subscribe(
                data => {
                    this.change.markForCheck();
                })
            );            
        }

        this._ticket_subscription = this._ticket.OnRefresh.subscribe(
        data => {
            this._RefreshTicket();
        })
    }

    ngOnDestroy(){
        super.OnDestroy();

        for(let _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];

        if (this._ticket_subscription){
            this._ticket_subscription.unsubscribe();
            this._ticket_subscription = null;
        }
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/

    @Output('onSelect') _onSelect = new EventEmitter<any>();         
    OnSelect(){
        this._onSelect.emit(this._discount);
    }

    private _discountprice = null;
    get Price(){
        if (this._discountprice == null){
            let _pricefnc = (_ticket: Ticket, _discount: Discount) => {
                let _price = 0;
                let _charge = _ticket._charge;

                // calculate the discount amount to be applied
                let _type = _discount?.type;
                if (_type == 'TICKETFIXED'){
                    _price = _discount.value;
                }
                if (_type == 'TICKETPRCNT'){
                    _price = Math.round(_charge * _discount.value) / 100;
                }

                // remove the discounted amount from the ticket charge
                for (let _discount of _ticket.discounts){
                    if (_discount.IsValid){
                        _charge -= _discount.charge;
                    }
                }
                
                // do not exeed the ticket current charge price
                return Math.min(_charge, _price);    
            }
    
            let _price = {
                Str: "0,00",
                Int: "0",
                Dec: "00",
                Val: 0.0,
                Neg: false
            };
    
            let _pricettl = _pricefnc(this._ticket, this._discount);
            if (_pricettl !== null){
                let _parts = Math.abs(_pricettl).toString().split('.');
    
                let _int = _parts[0];
                let _dec = (_parts.length > 1) ? (_parts[1] + '0').slice(0, 2) : "00";
                let _str = _int + ',' + _dec;
                let _val = _pricettl;
                let _neg = (_pricettl < 0); 
    
                _price = {
                    Int: _int,
                    Dec: _dec,
                    Str: _str,
                    Val: _val,
                    Neg: _neg
                }    
            }
    
            this._discountprice = _price;    
        }

        return this._discountprice;
    }
}
